import { render, staticRenderFns } from "./room-info.vue?vue&type=template&id=de9f6702&"
import script from "./room-info.vue?vue&type=script&lang=js&"
export * from "./room-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports